import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BulletinDataToUpdate, BulletinStatus } from "../types";

export const updateBulletin = async (
  bulletinId: string,
  bulletin: BulletinDataToUpdate,
): Promise<void> => {
  const bulletinDocRef = doc(db, "bulletins", bulletinId);

  try {
    if (bulletin.status) {
      await updateDoc(bulletinDocRef, {
        ...bulletin,
        publishedAt:
          bulletin.status === BulletinStatus.Draft
            ? null
            : bulletin.publishedAt || new Date(),
      });
    } else {
      await updateDoc(bulletinDocRef, {
        ...bulletin,
      });
    }

    await getDoc(bulletinDocRef);
  } catch (error) {
    console.error("Failed to update the bulletin:", error);
    throw error;
  }
};
